import { pipe } from 'fp-ts/function';
import { keys } from 'fp-ts/lib/Record';
import { filter, isEmpty } from 'fp-ts/lib/Array';
import { SignupBody } from '@oresundsbron/api';
import { Lens } from 'monocle-ts';
import { BusinessCustomerData } from '~/components/Forms/ContactInformation/Business';

export enum VerificationCodeResponseStatus {
  error = 'error',
  hide = 'hide',
  newCodeSent = 'newCodeSent',
}

export const isEntryEmpty = (entry: Record<string, string | boolean>) =>
  pipe(
    entry as Record<string, string>,
    keys,
    filter((key) => key !== 'country' && !!entry[key]),
    isEmpty
  );

export type VehicleOptionType = { label: string; value: string };

export type SignUpFormPart = {
  namespace: string;
  titleTranslationKey: string;
  ns: string[];
};

export const businessPhoneCode = Lens.fromPath<BusinessCustomerData>()([
  'contact',
  'phoneCode',
]);

export const businessPrivatePhoneCode = Lens.fromPath<BusinessCustomerData>()([
  'phoneCode',
]);

export const privatePhoneCode = Lens.fromPath<SignupBody>()([
  'contactInformation',
  'phoneCode',
]);
